import React, { useEffect, useState } from 'react'
import { BASE } from '../../basedata/constants'
import { fetchWithApiKey } from '../../config/apiCall'

export interface UserBiometryProps {
  imagePath: any
  imageSide?: any
}

const resolveDirectImage = (imagePath: string) => {
  const normalizedImage = `${imagePath || ''}`.trim()

  if (!normalizedImage || normalizedImage === '---') {
    return ''
  }

  if (
    normalizedImage.startsWith('data:image') ||
    normalizedImage.startsWith('http://') ||
    normalizedImage.startsWith('https://')
  ) {
    return normalizedImage
  }

  if (!normalizedImage.includes('/')) {
    return `data:image/png;base64,${normalizedImage}`
  }

  return ''
}

const resolveFetchedImage = (imageData: any) => {
  const normalizedImage = `${imageData || ''}`.trim()

  if (!normalizedImage) {
    return ''
  }

  if (normalizedImage.startsWith('data:image')) {
    return normalizedImage
  }

  return `data:image/png;base64,${normalizedImage}`
}

const UserBiometryImage = ({ imagePath }: UserBiometryProps) => {
  const [imageItem, setImageItem] = useState('')
  const [directImage, setDirectImage] = useState('')

  useEffect(() => {
    const normalizedImagePath = `${imagePath || ''}`.trim()
    const resolvedDirectImage = resolveDirectImage(normalizedImagePath)

    if (resolvedDirectImage) {
      setDirectImage(resolvedDirectImage)
      setImageItem('')
      return
    }

    if (!normalizedImagePath || normalizedImagePath === '---') {
      setDirectImage('')
      setImageItem('')
      return
    }

    let isMounted = true

    const getUsersBiometryImage = async () => {
      try {
        const response = await fetchWithApiKey(
          `${BASE.api_user.base_url}/biometry/getimageByPath`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              path: normalizedImagePath
            })
          }
        )

        const payload = await response.json()

        if (!isMounted) {
          return
        }

        setImageItem(resolveFetchedImage(payload?.image))
      } catch (error) {
        if (isMounted) {
          setImageItem('')
        }
      }
    }

    getUsersBiometryImage()

    return () => {
      isMounted = false
    }
  }, [imagePath])

  const finalImageSrc = directImage || imageItem

  if (!finalImageSrc) {
    return <span>-</span>
  }

  return <img src={finalImageSrc} alt="Documento" className="document-image" />
}

export default UserBiometryImage
